module.exports = __webpack_public_path__ + "img/a5a6f4d6c8219ea9882bb49e0f873cfa.svg";